(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elli-fit-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
const trigger=event.target.closest('[data-elli-fit-trigger]');if(!trigger)return;
const dock=document.getElementById(trigger.dataset.dockId);if(!dock)return;
const button=dock.querySelector('[data-elli-dock-target$="-size"]');if(!button)return;
if(button.getAttribute('aria-expanded')!=='true')button.click();
dock.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
button.focus({preventScroll:true});
});
  } catch(e) { console.error(e); }
})();

})();
